import { EmailInput } from '@/schemas/sceneDataSchema';
import { UseFormReturn } from 'react-hook-form';
import { GenericInput } from './GenericInput';

export const InputEmailFormElement = ({ form, component }: { form: UseFormReturn; component: EmailInput }) => {
  return (
    <GenericInput
      form={form}
      component={component}
      type='email'
    />
  );
};
